import type {
  DayHourQuery,
  DayHourResponse,
  VisitsAnalyticsQuery,
  VisitsAnalyticsResponse,
  VisitsEntriesQuery,
  VisitsEntriesResponse,
} from '@troia-v3/types';

import { api, type ApiResponse } from '@/lib/api';

export const dashboardsAnalyticsApi = {
  async getVisits(query: VisitsAnalyticsQuery): Promise<VisitsAnalyticsResponse> {
    const response = await api.get<ApiResponse<VisitsAnalyticsResponse>>(
      'dashboards/analytics/visits',
      { params: query },
    );
    return response.data.data!;
  },

  async getDayHour(query: DayHourQuery): Promise<DayHourResponse> {
    const response = await api.get<ApiResponse<DayHourResponse>>('dashboards/analytics/day-hour', {
      params: query,
    });
    return response.data.data!;
  },

  async getEntries(query: VisitsEntriesQuery): Promise<VisitsEntriesResponse> {
    const response = await api.get<ApiResponse<VisitsEntriesResponse>>(
      'dashboards/analytics/visits/entries',
      { params: query },
    );
    return response.data.data!;
  },
};
